import { render, staticRenderFns } from "./DetailInventory.vue?vue&type=template&id=508af46e&scoped=true"
import script from "./DetailInventory.vue?vue&type=script&lang=js"
export * from "./DetailInventory.vue?vue&type=script&lang=js"
import style0 from "./DetailInventory.vue?vue&type=style&index=0&id=508af46e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508af46e",
  null
  
)

export default component.exports